module.exports = __webpack_public_path__ + "img/logo_dark.6fd792f0.png";